import axiosPost from "./axiosPost";

export const usuarioFotoPerfilGet = async (usuarioId, credentials) => {
    const body = {
        service: "UsuarioFotoPerfilGet",
        params: {
            usuarioId: usuarioId,
        },
    };

    const result = await axiosPost(body, credentials);
    return result.result[0];
};
